<template>
  <div class="registry">
    <acHead></acHead>
    <div class="content">
      <div class="con-wrap">
        <slot></slot>
      </div>
    </div>
    <acFoot></acFoot>
  </div>
</template>

<script>
  import acHead from '../components/Header.vue'
  import acFoot from '../../component/Footer.vue'

  export default {
    components: {
      acHead,
      acFoot
    }
  }

</script>

<style lang="stylus" scoped>
  .content {
    width: 100%;
    min-height: 500px;
    height: 600px;
    position: relative;
    border-bottom: 1px solid #c1c1c1;
    box-sizing: border-box;
    .con-wrap {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      position: relative;
    }
  }

</style>



// WEBPACK FOOTER //
// Wrap.vue?572130fe